import{css}from'glamor';export default css({"float":'right',pointerEvents:'none'}).toString();